<template>
  <svg
    width="140"
    height="250"
    viewBox="0 0 140 250"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M81.5479 167.752L66.574 150.391L108.145 158.403L81.5479 167.752Z"
      fill="#7DB1A1"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M115.33 127.776C116.358 127.824 117.067 128.825 116.77 129.81L108.145 158.403L71.518 152.995L78.1879 127.324C78.3757 126.602 79.0434 126.11 79.7888 126.144L115.33 127.776Z"
      fill="#B3E0D0"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M113.015 129.774L105.505 156.152L73.9525 151.259L80.463 127.869L113.015 129.774Z"
      fill="#FFFFFE"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M63.3949 207.56L63.6743 238.096C58.9536 238.187 55.1567 239.01 54.5123 240.059L54.5027 240.048C52.9382 240.142 51.3435 240.243 49.8858 240.816C48.4281 241.389 47.1036 242.525 46.7191 244.038C46.3344 245.552 47.1723 247.391 48.6944 247.763C50.2165 248.134 51.9317 246.467 51.3243 245.028C51.206 244.748 51.0214 244.502 50.8372 244.257C50.6255 243.975 50.4142 243.693 50.3048 243.362C49.9617 242.321 50.5941 241.471 51.6241 241.089C52.3506 240.819 53.776 240.764 54.5534 240.755C55.214 241.652 58.1871 242.373 62.0431 242.595C60.4086 242.943 59.0057 244.485 59.0564 246.182C59.1199 248.308 61.4444 250.054 63.5131 249.531C65.573 249.009 66.7667 246.291 65.6264 244.503C64.9444 243.434 63.5437 243.025 62.3188 243.267L63.2054 242.645C63.6447 242.659 64.093 242.665 64.5482 242.665C69.1129 242.665 72.9725 241.984 74.2402 241.046C76.3488 241.02 78.1905 241.301 79.2484 242.487C78.6394 242.653 78.0616 242.906 77.5609 243.289C76.5766 244.042 75.9672 245.378 76.3539 246.553C76.8852 248.168 79.2094 248.72 80.5857 247.717C81.9617 246.714 82.2605 244.632 81.4835 243.12C81.3168 242.796 80.8285 242.181 80.8285 242.181C79.9574 241.216 78.684 240.604 77.3826 240.397C76.4597 240.25 75.5242 240.104 74.5996 240.086C74.0271 239.066 70.4854 238.256 65.994 238.111L65.7143 207.538L63.3949 207.56Z"
      fill="#3A3B39"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M52.212 207.45L74.6036 203.993C76.5567 210.504 58.5606 214.765 52.212 207.45Z"
      fill="#585755"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M82.7416 240.451L92.1817 239.583L86.9734 237.305L87.4617 230.252L82.7416 231.662V240.451Z"
      fill="#FB9300"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M101.188 246.202L112.69 244.792L105.854 241.971L106.939 232.965L102.273 234.592L101.188 246.202Z"
      fill="#FB9300"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M88.601 231.662H82.7416L80.463 192.925L95.7624 189.345L88.601 231.662Z"
      fill="#3F2C48"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M50.8406 207.248C59.9551 208.876 88.2755 207.026 88.1127 193.791L42.2686 198.785C42.2686 198.785 41.726 205.621 50.8406 207.248Z"
      fill="#3A3B39"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M70.0463 201.063C106.179 189.67 104.226 189.996 104.226 189.996L102.273 234.592H109.434C109.434 234.592 129.074 173.503 118.223 167.535C107.373 161.567 75.363 174.588 75.363 174.588L21.5437 182.183C21.5437 182.183 33.9135 212.457 70.0463 201.063Z"
      fill="#523B5D"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M42.2686 83.0081L40.9561 83.9847C40.9561 83.9847 42.4857 87.7822 41.8347 88.1077C41.1837 88.4333 39.3389 89.5186 39.3389 89.5186L40.4242 94.7269L31.6352 95.8119L30.8754 89.3014L31.5264 78.9932L38.5795 75.6296L42.2686 83.0081Z"
      fill="#F9B6A8"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M34.6732 87.8906C34.6732 87.8906 32.1775 86.5885 32.6114 85.1781C33.0456 83.7676 34.9988 84.0931 35.8666 85.8291L37.4942 85.5036L35.0274 78.4505C35.0274 78.4505 41.8461 76.541 40.8581 73.1338C39.518 68.5117 34.6072 70.2018 34.7468 74.1517C34.7468 74.1517 27.0775 74.9785 27.7286 79.1016C28.3796 83.2249 30.5671 90.9121 30.5671 90.9121L35.1072 90.0609L34.6732 87.8906Z"
      fill="#523B5D"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M38.7911 80.6312C38.4942 80.6312 38.2536 80.8717 38.2536 81.1686C38.2536 81.4655 38.4942 81.7061 38.7911 81.7061C39.088 81.7061 39.3285 81.4655 39.3285 81.1686C39.3285 80.8717 39.088 80.6312 38.7911 80.6312Z"
      fill="#3A3B39"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M37.1332 80.1305C37.0495 80.0983 37.0076 80.0042 37.0401 79.9202C37.182 79.5518 37.4903 79.2448 37.8848 79.0771C38.28 78.9098 38.7152 78.902 39.0785 79.056C39.1615 79.0908 39.1999 79.1865 39.1651 79.2692C39.1303 79.3525 39.0336 79.3903 38.9519 79.3558C38.669 79.236 38.3262 79.2435 38.0121 79.377C37.698 79.5101 37.4542 79.751 37.3435 80.0374C37.3188 80.1019 37.2572 80.1416 37.1918 80.1416C37.1723 80.1416 37.1524 80.138 37.1332 80.1305Z"
      fill="#3A3B39"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M74.6036 131.728C74.6036 131.728 65.1801 100.749 54.0958 95.8118C44.1072 91.363 18.2885 90.3864 9.82494 113.173C1.36139 135.959 21.5437 182.183 21.5437 182.183C21.5437 182.183 58.3275 189.67 80.463 173.394L59.3591 137.444L74.6036 131.728Z"
      fill="#EB5757"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M85.3458 162.326L101.947 158.42L105.528 153.537L106.179 153.755L105.203 157.227L111.821 156.142V157.118L106.505 158.637L111.821 157.878V158.746L106.939 160.156L111.821 159.722V160.807L107.373 161.567L110.954 161.784L110.628 162.326L103.792 163.303C103.792 163.303 79.378 180.881 75.363 174.588C71.3484 168.294 59.3591 137.444 59.3591 137.444L74.6036 131.728L85.3458 162.326Z"
      fill="#F9B6A8"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M57.7849 133.572L73.1866 127.46L74.6036 131.728L59.3591 137.444L57.7849 133.572Z"
      fill="#FFFFFE"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M111.821 187.717L104.06 193.791L104.226 189.996L111.821 187.717Z"
      fill="#3F2C48"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M34.711 202.355C21.1039 192.547 17.5766 170.277 17.4333 169.334L19.6859 168.991C19.7198 169.213 23.2195 191.269 36.0489 200.51C40.933 204.029 46.6117 205.261 52.9258 204.172L53.3129 206.418C51.6895 206.698 50.1036 206.838 48.5574 206.838C43.4906 206.838 38.849 205.338 34.711 202.355Z"
      fill="#3A3B39"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.64004 164.605C1.67357 158.424 -1.24277 148.655 5.59317 146.702C12.4291 144.748 28.0541 140.842 32.2859 146.702C36.5176 152.561 37.9281 169.162 30.8754 170.465C23.8223 171.767 15.0333 171.767 15.0333 171.767C15.0333 171.767 5.91869 171.767 3.64004 164.605Z"
      fill="#585755"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M95.7624 101.562H113.015L111.822 115.017L94.1781 111.979L95.7624 101.562Z"
      fill="#F9B6A8"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M113.015 56.4238L138.84 60.764L133.631 81.1686L108.145 74.653L113.015 56.4238Z"
      fill="#F9B6A8"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M96.5222 42.3177L130.376 30.3822L121.696 0L86.1055 18.4463L96.5222 42.3177Z"
      fill="#F9B6A8"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M130.201 29.7695L110.351 20.932L121.884 0.657552L121.695 0L120.899 0.41276L107.997 23.0957L86.7709 18.1012L86.1055 18.4463L86.3494 19.0052L104.082 23.1777L96.2527 41.7005L96.5222 42.3177L97.1449 42.098L105.047 23.4046L108.484 24.2135L109.866 21.7848L129.706 30.6182L130.376 30.3822L130.201 29.7695Z"
      fill="#CC395D"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M137.992 60.6214L121.86 68.18L113.691 56.5371L113.015 56.4235L112.851 57.0391L119.337 66.2839L108.34 73.9228L108.145 74.6527L108.771 74.8128L119.898 67.0833L121.532 69.4121L125.716 67.4518L132.989 81.0042L133.631 81.1683L133.81 80.4687L126.601 67.0368L138.683 61.3763L138.84 60.764L137.992 60.6214Z"
      fill="#CC395D"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M112.351 101.563L102.637 107.027L96.2624 101.563H95.7624L95.7048 101.942L100.937 106.427L94.2484 111.517L94.1781 111.979L94.6163 112.055L101.442 106.86L102.56 107.818L104.316 106.829L111.316 114.931L111.821 115.018L111.862 114.566L104.896 106.504L112.98 101.956L113.015 101.563H112.351Z"
      fill="#CC395D"
    />
  </svg>
</template>